<template>
  <div class="product-demo">

    <div class="product-demo-top">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="product-demo-top-content">
            <h2>天鸿产品演示</h2>
            <!-- <p>这一段演示文字,立即进行企业实名认证,可以领取以下企业试用产品 活动规则</p> -->
            <p>&nbsp;</p>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="product-demo-cent">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="product-demo-cent-content">
                <div class="emo-cent">
					<Modal v-model="modal1" width="400" scrollable="true" footer-hide="true">
					        <p slot="header" style="color:#2D8CF0;">
					            <Icon type="ios-information-circle"></Icon>
					            <span>联系我们</span>
					        </p>
					        <div style="margin-bottom: 25px;padding-top: 15px;    font-size: large;">
								<p style="margin-bottom: 10px;">电话号码：027—87854441</p>
								<p>邮箱地址：master@thonline.com.cn</p>
					        </div>
					        <!-- <div slot="footer"> -->
<!-- 					            <Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button> -->
					        <!-- </div> -->
					    </Modal>
                  <div class="product-demo-cent-img" @click="modal1 = true">
                    <img class="product-demo-img1" src="../assets/img/icon.png" width="80%"/>
                    <img  class="product-demo-img2" src="../assets/img/di.png" width="80%"/>
                    <p>综合运维管理系统</p>
                  </div>
                  <div class="product-demo-cent-interval"></div>
                  <div class="product-demo-cent-img" @click="modal1 = true">
                    <img class="product-demo-img1" src="../assets/img/icon.png" width="80%"/>
                    <img  class="product-demo-img2" src="../assets/img/di.png" width="80%"/>
                    <p>物联网网关</p>
                  </div>
                  <div class="product-demo-cent-interval"></div>
                  <div class="product-demo-cent-img" @click="modal1 = true">
                    <img class="product-demo-img1" src="../assets/img/icon.png" width="80%"/>
                    <img  class="product-demo-img2" src="../assets/img/di.png" width="80%"/>
                    <p>物联网综合管理平台</p>
                  </div>
                  <div class="product-demo-cent-interval"></div>
                  <div class="product-demo-cent-img" @click="modal1 = true">
                    <img class="product-demo-img1" src="../assets/img/icon.png" width="80%"/>
                    <img  class="product-demo-img2" src="../assets/img/di.png" width="80%"/>
                    <p>应用集成平台</p>
                  </div>
                  <div class="product-demo-cent-interval"></div>
                  <div class="product-demo-cent-img" @click="modal1 = true">
                    <img class="product-demo-img1" src="../assets/img/icon.png" width="80%"/>
                    <img  class="product-demo-img2" src="../assets/img/di.png" width="80%"/>
                    <p>数据中台</p>
                  </div>
                <!--              <div class="service-img">

                              </div> -->
              </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'ProductDemo',
	        data () {
	            return {
	                modal1: false
	            }
	        },
	        methods: {
	            ok () {
	                this.$Message.info('Clicked ok');
	            },
	            cancel () {
	                this.$Message.info('Clicked cancel');
	            }
	        }
	    }
</script>

<style lang="less" scoped="scoped">
  .product-demo{
    .product-demo-top{
      background-size: 100% 100%;
      background-image: url(../assets/img/banner1.png);
      background-repeat: no-repeat;
      padding-top: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .product-demo-top-content{
        text-align: center;
        color: #ffffff;
        padding-bottom: 1rem;
        h2{
           font-family: SourceHanSansCN-Medium;
           font-size: 30px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 0px;
           letter-spacing: 0px;
           color: #ffffff;
          margin-top: 1rem;
          margin-bottom: 0.2rem;
        }
        // p{
        //    font-family: SourceHanSansCN-Regular;
        //    font-size: 24px;
        //    font-weight: normal;
        //    font-stretch: normal;
        //    // line-height: 0px;
        //    letter-spacing: 0px;
        //    color: #333333;
        // }
      }
    }
    .product-demo-cent{
      text-align: center;
      // padding: 0.5rem;
      background-color: #f4f5fa;
      height: 3.7rem;
      .product-demo-cent-content{

      }
      .emo-cent{
        display: flex;
        padding: 0.5rem;
        .product-demo-cent-img{
          flex: 2;
          .product-demo-img1{
            margin-bottom: -0.3rem;
          }
          .product-demo-img2{
            margin-top: -1rem;
          }
        }
        .product-demo-cent-interval{
          flex: 1;
        }

      }
    }
  }

  .product-demo-cent-img .product-demo-img2{
    opacity: 0;
  }
  .product-demo-cent-img:hover .product-demo-img2 {
    opacity: 1;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ProductDemo.vue